import { render } from "./Severity.vue?vue&type=template&id=53c9fe46"
import script from "./Severity.vue?vue&type=script&lang=js"
export * from "./Severity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__